<template src="./administration.html">

</template>

<script>

import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import { hasAdminClaim, hasUserManageClaim, hasUserViewClaim, hasUserReviewClaim, hasUserUpdateAllClaim, hasUserStatusUpdateClaim, hasUserStatusUpdateAllClaim, hasRoleViewClaim, hasRoleManageClaim, hasOrganizationViewClaim, hasOrganizationRegistrationResolveClaim } from '@/router/auth.js'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      test: false,
      help: {
        root: Vue.$helpConfig.administration
      }
    }
  },
  created () {
    this.logConsole('Administration created')
  },
  computed: {
    displayOrganizationMenu () {
      return hasAdminClaim() || hasOrganizationViewClaim() || hasOrganizationRegistrationResolveClaim()
    },
    displayRoleMenu () {
      return hasAdminClaim() || hasRoleViewClaim() || hasRoleManageClaim()
    },
    displayUserMenu () {
      return hasAdminClaim() || hasUserReviewClaim() || hasUserViewClaim() || hasUserManageClaim() || hasUserUpdateAllClaim() || hasUserStatusUpdateClaim() || hasUserStatusUpdateAllClaim()
    }
  }
}
</script>
